export const contains = (str1, str2) => {
  return (str1 || "").toLowerCase().indexOf((str2 || "").toLowerCase()) !== -1;
};
